import {RrcEp10WasteManifestEntity,} from "@ots-frontend/ots-data";
import {useCallback} from "react";
import {RrcEp10WasteManifestAction} from "./RrcEp10WasteManifestActionMenu";
import {useDownloadRrcEp10WasteManifest} from "../../../hooks/useDownloadRrcEp10WasteManifest";
import {useApp} from "../../../providers/RegionProvider/RegionProvider";

export type UseRrcEp10WasteManifestActionProps = {}

export type UseRrcEp10WasteManifestActionResult = {
  onRrcEp10WasteManifestActionClick: (rrcEp10WasteManifest: RrcEp10WasteManifestEntity, action: RrcEp10WasteManifestAction) => void;
}

export const useRrcEp10WasteManifestAction = (props: UseRrcEp10WasteManifestActionProps = {}): UseRrcEp10WasteManifestActionResult => {
  const {} = props

  const {baseQueryApi} = useApp()

  const {
    downloadRrcEp10WasteManifest,
  } = useDownloadRrcEp10WasteManifest({baseQueryApi})

  const _onRrcEp10WasteManifestActionClick = useCallback((rrcEp10WasteManifest: RrcEp10WasteManifestEntity, action: RrcEp10WasteManifestAction) => {
    if (action === "DOWNLOAD") {
      downloadRrcEp10WasteManifest(rrcEp10WasteManifest.id, rrcEp10WasteManifest.tenantCode)
    }
  }, [downloadRrcEp10WasteManifest])

  return {
    onRrcEp10WasteManifestActionClick: _onRrcEp10WasteManifestActionClick
  }
}
